module.exports = __webpack_public_path__ + "static/media/LGSmartLight__W.95cd659d.woff";